import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getMIPInvestorQuickLinksData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { buildQuickLinks } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/quickLinks.utils.ts';
import { QuickLink } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/quickLinks.types.ts';

interface Props {
	dealId: string;
	mipId: string;
	investorId: string;
}

interface Result {
	links: QuickLink[];
	isLoading: boolean;
	isError: boolean;
}

export const useInvestorQuickLinks = ({ dealId, mipId, investorId }: Props): Result => {
	const tMipManage = useTranslationMipManage();

	const quickLinksQuery = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_QUICK_LINKS_ID_GET, { investorId }],
		queryFn: ({ signal }) =>
			getMIPInvestorQuickLinksData(
				API_PATHS.MIP_INVESTOR_QUICK_LINKS_ID_GET,
				{ investorId },
				signal
			),
	});

	const counts = quickLinksQuery.data?.payload;

	const links = useMemo(
		() =>
			buildQuickLinks({
				counts,
				dealId,
				mipId,
				investorIds: [investorId],
				tMipManage,
			}),
		[counts, dealId, mipId, investorId, tMipManage]
	);

	return {
		links,
		isLoading: quickLinksQuery.isPending,
		isError: quickLinksQuery.isError,
	};
};
